/**
 * Preload
 * ------------------------------------------------------- *
 */

const preload =  ( function( document, window ) {
	const _instance = {};

	/**
	 * Public
	 */
	_instance.init = function() {
		window.addEventListener( 'load', function() {
			document.body.classList.remove( 'preload' );
		});
	};

	return _instance;

}( document, window ) );

export default  preload;
